import * as Yup from "yup";

export const validationSchema = Yup.object({
  taluka_id: Yup.string().required("Taluka is required!"),
  name: Yup.string().required(" Village name is required!"),
  is_active: Yup.string().required("Status is required!"),
});
